<template>
  <SectionLayout id="layout_setting" title="Layout Setting">
    <div class="layout__setting-body d-flex align-items-start">
      <PlanPermissionWrapper :click="() => {}" :permission-type="feature">
        <template #default="{ disabled }">
          <Switcher v-if="!disabled" v-model:value="headerFooter" padding="p-0" :inline="false" type="switch" custom>
            <div class="layout__setting-content d-flex flex-column ml-1">
              <span class="layout__setting-title text-light-high body-14-16-regular mb-1">Show Header & Footer</span>
              <span class="layout__setting-desc text-light-low body-12-regular">
                Hide or Show header & footer on your page. To edit those sections, please go to
                <a target="_blank" :href="adminThemeLink" class="text-mono3" @click.stop>Theme Setting</a>
              </span>
            </div>
          </Switcher>
          <div v-else class="advance__setting-content d-flex flex-column w-full">
            <div class="!mb-2 flex items-center justify-between">
              <span
                class="advance__setting-title text-light-high body-14-16-regular"
                :class="disabled ? 'text-light-disabled' : 'text-light-high'"
                >Header & Footer</span
              >
              <a :data-href="pricingUrl" class="gp-open-new-tab cursor-pointer text-sm font-medium text-blue-300"
                >Upgrade to set up</a
              >
            </div>
            <span
              class="advance__setting-desc body-12-regular"
              :class="disabled ? 'text-light-disabled' : 'text-light-low'">
              In some cases, you will need to hide your header & footer to reduce distractions for your page. Upgrade
              your plan to configure this setting
            </span>
          </div>
        </template>
      </PlanPermissionWrapper>
    </div>
  </SectionLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SectionLayout from './SectionLayout.vue';
import { mapGetters } from 'vuex';
import type { IfLayoutSettingForm } from '@/store/page/types';
import config from '@/app/editor/config';
import Switcher from '@/core/components/essenstials/Switcher.vue';
import { PlanPermissionWrapper, FEATURE_TYPES } from '@modules/common';
import goToPricing from '@/mixins/goToPricing';

interface IfLayoutSetting {
  // vuex
  currentForm: IfLayoutSettingForm;
  defaultForm: IfLayoutSettingForm;
  domain: string;
  // computed
  form: IfLayoutSettingForm;
  adminThemeLink: string;
}

/* eslint-disable vue/no-unused-components */
export default defineComponent({
  name: 'LayoutSetting',
  components: {
    SectionLayout,
    Switcher,
    PlanPermissionWrapper,
  },
  mixins: [goToPricing],
  data: () => ({
    onHeaderFooterThumbnail: `${config.domain()}${config.baseURL()}/images/page-setting/HeaderFooterOn.svg`,
    offHeaderFooterThumbnail: `${config.domain()}${config.baseURL()}/images/page-setting/HeaderFooterOff.svg`,
    feature: FEATURE_TYPES.LAYOUT_HEADER_FOOTER,
  }),
  computed: {
    ...mapGetters('app', {
      domain: 'shopifyDomain',
    }),
    ...mapGetters('page', {
      defaultForm: 'layoutDefaultForm',
      currentForm: 'layoutForm',
    }),
    headerFooter: {
      get() {
        return this.currentForm.headerFooter;
      },
      set(value: any) {
        this.$store.commit('page/UPDATE_PAGE_SETTING_FORM', {
          tab: 'layout',
          field: 'headerFooter',
          value,
        });
      },
    },
    adminThemeLink() {
      return `https://${this.domain}/admin/themes`;
    },
  },
});
</script>

<style lang="scss">
.layout__setting-toggler {
  flex: 0 0 34px;
}
</style>
